(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class FofCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.fof__track');
      this.cards = Array.from(this.querySelectorAll('.fof__card'));
      this.prevButton = this.querySelector('[data-fof-prev]');
      this.nextButton = this.querySelector('[data-fof-next]');
      if (!this.track || this.cards.length === 0) return;

      this.prevButton?.addEventListener('click', () => this.go(-1));
      this.nextButton?.addEventListener('click', () => this.go(1));
    }

    step() {
      const trackStyle = getComputedStyle(this.track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
      return this.cards[0].getBoundingClientRect().width + gap;
    }

    go(direction) {
      const step = this.step();
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atStart = this.track.scrollLeft <= 1;
      const atEnd = this.track.scrollLeft >= maxScroll - 1;
      const behavior = reducedMotion.matches ? 'auto' : 'smooth';

      if (direction > 0 && atEnd) {
        this.track.scrollTo({ left: 0, behavior });
        return;
      }
      if (direction < 0 && atStart) {
        this.track.scrollTo({ left: maxScroll, behavior });
        return;
      }
      this.track.scrollBy({ left: direction * step, behavior });
    }
  }

  customElements.define('fof-carousel', FofCarousel);
})();
